// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"3ce652d8","71":"69169aaf","215":"bdc7a28f","219":"08d09eb7","620":"d69ce9e3","712":"5a6e54e8","837":"bac16f76"}[chunkId] + ".chunk.js";
};